import React from 'react';
import {Route} from 'react-router';
import {createBrowserHistory} from "history";
import {Router, Switch} from "react-router-dom";

import indexRoutes from "./routes/routes";
import {MetaTags} from "react-meta-tags";

var hist = createBrowserHistory();

const RouterNode = ({props}) => {
    return (
        <div>
            <MetaTags>
                <title>Chris Wrobel Website</title>
                <meta property="og:title" content="Chris Wrobel Website"/>

                <meta name="description" content="Personal website of an Entrepreneur, Developer, Speaker and Technology Evangelist helping others embrace
                                    new technologies and grow their businesses." />
                <meta property="og:description" content="Personal website of an Entrepreneur, Developer, Speaker and Technology Evangelist helping others embrace
                                    new technologies and grow their businesses."/>

                <meta property="og:type" content="website"/>
                <meta property="og:image" content="/static/media/preview.jpg"/>
                <meta property="og:url" content="https://chriswrobel.com"/>
            </MetaTags>
            <Router history={hist} basename={process.env.PUBLIC_URL}>
                <Switch>
                    {
                        indexRoutes.map((prop, key) => {
                            return <Route path={prop.path} key={prop.name} component={prop.component}/>;
                        })}
                </Switch>
            </Router>
        </div>
    );
};

export default RouterNode;


// WEBPACK FOOTER //
// ./src/router.js